import Layout from "../shared/Layout";
import PageHeader from "../shared/PageHeader";
import "../../css/conversations.css";
import ConversationTemplatesSection from "./ConversationTemplatesSection";

export default function ConversationListView() {
    return (
        <Layout>
            <PageHeader name="Бот конструктор розмов" />
            <main className="main-block">
                <div style={{ margin: "1%" }}>
                    <ConversationTemplatesSection />
                </div>
            </main>
        </Layout>
    );
}
